import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'ai-tool', {
    switchAgentHandoffFailed: 'Handoff to {{botGroup}}/{{botHandle}} failed{{errorSuffix}}',
    switchAgentHandoffIncomplete: 'Handoff to {{botGroup}}/{{botHandle}} could not be completed.',
    switchAgentControlTransferred:
      'Control transferred from {{sourceBotName}} to {{targetBotName}}',
  });

  i18next.addResourceBundle('en', 'agent-ui', {
    defaultBotNotFound:
      'Default bot not found ({{botGroup}}/{{botHandle}}). Seed the database or update NEXT_PUBLIC_DEFAULT_BOT_GROUP and NEXT_PUBLIC_DEFAULT_BOT_HANDLE.',
    newConvo: 'New convo',
    newConvoWithBot: 'New convo with “{{botName}}”',
    projectPhasePaused: '{{phase}} · Paused',
    pauseProject: 'Pause project',
    resumeProject: 'Resume project',
    pauseProjectReason: 'Why are you pausing this project?',
  });
}
